/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './describeServer.defs.js'
export * as $defs from './describeServer.defs.js'
